<!--
  App.vue
    Main Vue Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div>
    <router-view />  <!-- LoginCheckするためにrouterを使う -->
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { ROUTE_PATH } from '@/router/routes'

export default {
  name: 'App',
  mounted: function () {
    this.$log.debug('# App')
    this.$log.debug(this.$vuetify.breakpoint)
    this.$log.info(this.$vuetify.breakpoint.name)

    this.checkDisplaySize()

    this.$router.push(ROUTE_PATH.ROUTE_MAIN_CONTENT)
  },
  destroyed: function () {
    this.$log.debug('# App')
  },
  methods: {
    // -------------------------------------------------------------------------
    // 画面サイズ判定
    checkDisplaySize: function () {
      this.$store.commit('setIsMobile', this.$vuetify.breakpoint.xsOnly)
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue